import { forwardRef } from 'react';
import { useTranslations } from 'next-intl';
import { LocationIcon } from '@/component/Icons/LocationIcon';
import { CloseIcon } from '@/component/Icons/CloseIcon';
import styles from './LocationInput.module.css';

function LocationInputView(props, ref) {
  const {
    className = '',
    isFocused,
    onFocus,
    onBlur,
    value,
    onChange,
    onReset,
    tabIndex,
    theme,
  } = props;
  const t = useTranslations();
  return (
    <div
      className={`${styles.box} search-input-box ${
        isFocused ? 'bg-slate-100 !border-slate-300' : ''
      } ${className}`}
    >
      <div className={styles.input}>
        <span
          className={`icon-input ${styles.icon} ${
            isFocused ? '!text-teal-600' : ''
          }`}
        >
          <LocationIcon />
        </span>

        <div className="flex flex-col gap-1.5 w-full">
          <label className="text-xs text-slate-600 truncate inline-block h-[18px] mt-[-4px] mb-[-5px]">
            <span>{t('where')}</span>
          </label>
          <input
            className={`font-medium inline-flex h-[19px] w-full mt-[-4px] mb-[-5px] placeholder:text-slate-400 bg-transparent focus:outline-none text-black max-sm:text-sm leading-[10px] input-location truncate search-item-input pr-6 ${theme === 'vertical' ? 'text-[14px]' : ''}`}
            onFocus={onFocus}
            onBlur={onBlur}
            value={value}
            placeholder={t('search-location')}
            onChange={onChange}
            ref={ref}
            tabIndex={tabIndex}
          />
        </div>
      </div>

      {Boolean(value) && (
        <button
          className="bg-transparent self-center"
          type="button"
          onClick={onReset}
          tabIndex={tabIndex}
        >
          <CloseIcon />
        </button>
      )}
    </div>
  );
}

export const LocationInput = forwardRef(LocationInputView);
